import { useContext } from 'react';
import AppContext from '../../../store/app-context';

import { FaMap, FaPhone } from 'react-icons/fa';
import './Address.scss';

type addressProps = {
    data: any
};

const Address = (props: addressProps) => {
    const appCtx = useContext(AppContext);
    const address = props.data;

    const hasValidCoordinates = address.latitude && address.longitude;
    const hasGeolocation = appCtx.geolocation.latitude && appCtx.geolocation.longitude;

    return (
        <section className="address">
            {address.university && <div>{address.university}</div>}
            <div>{address.streetNumber ? address.streetNumber + ', ' : ''}{address.address1}</div>
            {address.address2 && <div>{address.address2}</div>}
            {address.city && <div>{address.city}</div>}
            <div>
                {address.county && <span>{address.county}, </span>}
                <span>{address.postcode}</span>
            </div>
            <div className="contact-links">
                {hasValidCoordinates && (
                    <a
                        href={hasGeolocation
                            ? `https://www.google.co.uk/maps/dir/${appCtx.geolocation.latitude},${appCtx.geolocation.longitude}/${address.latitude},${address.longitude}`
                            : `https://www.google.co.uk/maps/search/?api=1&query=${address.latitude},${address.longitude}`
                        }
                        target="_blank"
                        rel="noreferrer"
                    >
                        <FaMap />
                        Get directions
                    </a>
                )}
                {address.phone && (
                    <a href={'tel:' + address.phone}>
                        <FaPhone />
                        {address.phone}
                    </a>
                )}
            </div>
        </section>
    );
};

export default Address;